<template>
  <div class="footer">
    <div class="text-link">
      <el-link class="footer-link" :underline="false" href="#/about">关于我们</el-link>&emsp;|&emsp;
      <el-link class="footer-link" :underline="false" href="#/contact">联系我们</el-link>&emsp;|&emsp;
      <el-link class="footer-link" :underline="false" href="#/opinion">意见反馈</el-link>
    </div>
    <!-- <div class="hison-code" :style="{backgroundImage:'url('+informationList.wechat_img_url+')',backgroundSize:'100% 100%'}"></div> -->
    <div class="copyright"><a href="https://beian.miit.gov.cn/" target="_blank">{{informationList.copyright}}</a></div>
  </div>
</template>

<script>
import baseApi from "@/api/base";
import { getStorage } from "@/common/js/localstorage";

export default {
  name: "Footer",
  data() {
    return {
      schoolId: 0,
      schoolType: 0,
      informationList: {}
    };
  },
  created() {
    this.getSchoolId();
  },
  mounted() {
    this.getInformationList();
  },
  methods: {
    // 先判断是否登录，再判断区域用户还是学校用户，并设置school_id
    getSchoolId() {
      this.informationList = getStorage("school");
      if(this.informationList){
        this.schoolId = this.informationList.org_id;
        this.schoolType = this.informationList.org_type;
      }
    },
    // 获取底部机构网站信息
    getInformationList() {
      let paramsData = {
          org_id: this.schoolId,
          org_type: this.schoolType
      }
      baseApi.getInformationList(paramsData).then((response) => {
        if (response.data.status == 0) {
          this.informationList = response.data.data;
        } else {
          // console.log(response.data.info.detail);
          // this.$message({
          //   type: "warning",
          //   message: response.data.info.message,
          // });
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.footer {
  height: 160px;
  width: 100%;
  background: #002448;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 25px;
  box-sizing: border-box;

  .hison-code {
    width: 70px;
    height: 70px;
  }

  .footer-link {
    margin: 0 5px;
  }

  .copyright, .text-link, .el-link--default {
    color: #999999;
    font-size: 14px;
  }

  .copyright a {
    color: #999999;
    text-decoration: none;
  }

  .copyright a:hover {
    color: #569AF8;
  }

  .el-link--default:hover {
    color: #569AF8;
  }
}
</style>
